import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import { Badge, Space, Typography } from '@sravni/react-design-system';

import { CurrencyFormatter } from 'shared/lib';

import { calculateShortDebt } from '../lib/calculate';
import { formatDateWithOffset } from '../lib/formatDateWithOffset';

const { Text, Heading } = Typography;

export const ShortRefundInfo = () => {
  const { watch } = useFormContext();

  const amount = watch('amount');
  const period = watch('period');

  const isDaysPeriod = amount < 100_000;

  const validPeriod = isDaysPeriod ? period : period * 30;

  const isWithoutOverpayment = Number(validPeriod) < 22;

  const amountWithOverpayment = calculateShortDebt(Number(amount), Number(validPeriod));

  const repaymentDate = formatDateWithOffset(Number(validPeriod) - 1);

  return (
    <Space>
      <Space
        direction="column"
        size={4}
      >
        <Text>К возврату {repaymentDate}</Text>
        <Space
          direction="row"
          size={8}
          align="center"
        >
          <Heading level={4}>
            {CurrencyFormatter.formatCurrency(isWithoutOverpayment ? amount : amountWithOverpayment)}
          </Heading>
          {isWithoutOverpayment && (
            <Text
              lineThrough
              className="h-color-D60"
            >
              {CurrencyFormatter.formatCurrency(amountWithOverpayment)}
            </Text>
          )}
          {isWithoutOverpayment && (
            <Badge
              text="Бесплатно"
              color="blue"
              variant="primary"
            />
          )}
        </Space>
      </Space>
    </Space>
  );
};
